import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MdwDialog } from '@spaces-ui/meadow/components/dialog';
import { MdwInput } from '@spaces-ui/meadow/components/input';

@Component({
  selector: 'app-simple-form-dialog',
  imports: [CommonModule, MdwDialog, MdwInput],
  templateUrl: './simple-form-dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './simple-form-dialog.scss',
})
export class SimpleFormDialog {}
